import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './NewbuildingMortgageSection.css';

export interface INewbuildingMortgageSectionProps {
  header: string;
  showHeader?: boolean;
}

export const NewbuildingMortgageSection: React.FC<React.PropsWithChildren<INewbuildingMortgageSectionProps>> = ({
  children,
  showHeader,
  header,
}) => {
  return (
    <div className={styles['container_redesigned']} data-testid="NewbuildingMortgageSection" id="servicePlaceOverMap">
      {showHeader && (
        <div className={styles['title']}>
          <UIHeading1 as="h1">{header}</UIHeading1>
        </div>
      )}
      {children}
    </div>
  );
};
